<template>
  <div class="choose-notice pct100 flex-layout">
    <el-input
      class="margin10"
      :placeholder="placeholder"
      readonly
      v-model="noticeName"
      :disabled="disabled"
    >
      <el-button
        slot="suffix"
        type="text"
        :disabled="disabled"
        @click="queryNotice"
        >选择</el-button
      >
    </el-input>
    <el-dialog
      title="选择消息通知人"
      v-dialogDrag
      :visible.sync="showDialog"
      @close="close"
    >
      <div class="flex-row select-area valign-center mb10">
        <div>已选人员：</div>
        <div
          class="select-item"
          :title="item.name"
          v-for="(item, index) in selectedList"
          :key="index"
        >
          {{ getNoticeStr(item) }}
        </div>
      </div>
      <div class="search-area flex-row">
        <el-input
          class="search-input"
          clearable
          @clear="startSearch"
          v-model="searchText"
          placeholder="请输入搜索关键字"
        ></el-input>
        <el-button type="primary" @click="startSearch">搜索</el-button>
        <el-button type="info" @click="resetSearch">重置</el-button>
      </div>
      <div class="flex-valign content-area">
        <el-table
          ref="dataTable"
          size="mini"
          class="flex-auto"
          max-height="100%"
          :data="personList"
          @row-click="rowClick"
          :highlight-current-row="!mutilSelect"
          @selection-change="selectPerson"
          @select="selectRow"
          @select-all="selectAll"
        >
          <el-table-column v-if="!mutilSelect" label="选择" width="50">
            <template slot-scope="scope">
              <el-radio
                v-model="personnelCode"
                :label="scope.row.personnelCode"
              >
                <span></span>
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column v-if="mutilSelect" type="selection" width="50">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column label="类型" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.personnelType === 1 ? "员工" : "访客" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="姓名"
            prop="name"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="工号"
            prop="workNo"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="手机号"
            prop="phone"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="车牌号"
            prop="plateCode"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          class="mt10 flex-center"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageInfo.pageSize"
          :total="total"
          :current-page="pageInfo.pageNum"
          @size-change="sizeChange"
          @current-change="pageChange"
        />
      </div>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="submit">{{
          $t("workOrder.button.confirm")
        }}</el-button>
        <el-button @click="close">{{
          $t("workOrder.button.cancel")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import utils from '@src/common/utils'
export default {
  name: "choose-notice",
  model: {
    prop: "selectNotice",
    event: "handleReturn",
  },
  props: {
    selectNotice: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mutilSelect: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  watch: {
    selectNotice(newVal) {
      this.buildNotices();
    },
    notices(newVal) {
      this.notices = newVal;
      this.$emit(
        "handleReturn",
        this.notices
          .map((item) => {
            // 传给后台的数据结构如下：
            // name-plateCode:personnelCode-vehicleCode
            // 谢剑良-苏A66778:20200811000024-20200916000031
            // name-:personnelCode-
            // 谢剑良-:20200811000024-
            return (
              item.name +
              "-" +
              (item.plateCode || "") +
              ":" +
              item.personnelCode
            );
          })
          .join("|")
      );
    },
  },
  computed: {
    noticeName() {
      return this.selectedList
        .map((item) => {
          return (
            item.name.split("-")[0] +
            (item.name.split("-")[1] ? "(" + item.name.split("-")[1] + ")" : "")
          );
        })
        .join("、");
    },
    // 该属性为单选操作时，用于标记当前选中的节点
    personnelCode() {
      return (
        this.selectedList &&
        this.selectedList.length >= 1 &&
        this.selectedList[0].personnelCode
      );
    },
  },
  data() {
    return {
      notices: [],
      selectedList: [],
      showDialog: false,
      personList: [],
      searchText: "",
      pageInfo: { pageNum: 1, pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10 },
      total: 0,
    };
  },
  mounted() {
    this.oldList = [];
    this.buildNotices();
  },
  methods: {
    getNoticeStr(item = {}) {
      if (item.name && item.name.indexOf("-") !== -1) {
        return (
          item.name.split("-")[0] +
          (item.name.split("-")[1] ? "(" + item.name.split("-")[1] + ")" : "")
        );
      } else {
        return item.name + (item.plateCode ? "(" + item.plateCode + ")" : "");
      }
    },
    buildNotices() {
      if (this.selectNotice && this.selectNotice.length) {
        let notices = this.selectNotice.split("|");
        if (notices && notices.length) {
          let list = [];
          notices.forEach((item) => {
            list.push({
              name: item.split(":")[0],
              personnelCode: item.split(":")[1],
            });
          });
          this.oldList = list;
          this.selectedList = list;
        }
      }
    },
    selectAll(selection) {
      // 如果当前是全选，则将当前选中的所有数据拼接至结果中，然后去重
      if (selection.length) {
        let selectedList = this.selectedList.concat(selection);
        this.selectedList = this.$utils.unRepeatArray(
          selectedList,
          "personnelCode"
        );
      } else {
        // 如果当前是全不选，则将当前页中的数据从结果数据中删除
        let selectedList = this.selectedList.filter((item) => {
          return this.allIds.indexOf(item.personnelCode) === -1;
        });
        this.selectedList = selectedList;
      }
    },
    selectRow(selection, row) {
      let selectedIds = selection.map((item) => {
        return item.personnelCode;
      });
      // 如果当前点击的行不在选中的列表中，则需要将当前行从选中列表中删除
      if (selectedIds.indexOf(row.personnelCode) === -1) {
        let selectedList = this.selectedList.filter((item) => {
          return row.personnelCode !== item.personnelCode;
        });
        this.selectedList = selectedList;
      } else {
        // 如果当前选中的行在选中列表中，则需要将当前行加入到选中列表中，并进行去重操作
        let selectedList = this.selectedList.concat([row]);
        this.selectedList = this.$utils.unRepeatArray(
          selectedList,
          "personnelCode"
        );
      }
    },
    selectPerson(selection) {
      // 该方法不支持同时选择多页数据
      // this.selectedList = selection;
    },
    rowClick(row) {
      if (this.mutilSelect) {
        return;
      }
      this.selectedList = [row];
    },
    queryNotice() {
      this.queryPerson();
      this.showDialog = true;
    },
    submit() {
      this.notices = this.selectedList;
      this.oldList = this.selectedList;
      this.showDialog = false;
    },
    close() {
      this.selectedList = this.oldList;
      this.showDialog = false;
    },
    sizeChange(size) {
      this.pageInfo.pageNum = 1;
      this.pageInfo.pageSize = size;
      this.queryPerson();
    },
    pageChange(page) {
      this.pageInfo.pageNum = page;
      this.queryPerson();
    },
    resetSearch() {
      this.searchText = "";
      this.pageInfo.pageNum = 1;
      this.queryPerson();
    },
    startSearch() {
      this.pageInfo.pageNum = 1;
      this.queryPerson();
    },
    queryPerson() {
      if (this.searching) {
        return;
      }
      let selecteds = this.selectedList.map((item) => {
        return item.personnelCode;
      });
      this.searching = true;
      let param = {
        queryStr: this.searchText,
        ...this.pageInfo,
      };
      this.allIds = [];
      /**
       * 查询消息通知列表接口
       */
      this.$fetch(api.workOrder.queryPersonnelVehicleList, param).then(
        (res) => {
          this.searching = false;
          if (res.success) {
            this.personList = res.returnObj.list;
            let selectedIndexs = [];
            this.personList.forEach((item, index) => {
              item.personnelCode =
                item.personnelCode +
                "-" +
                (item.vehicleCode ? item.vehicleCode : "");
              this.allIds.push(item.personnelCode);
              if (selecteds.indexOf(item.personnelCode) !== -1) {
                selectedIndexs.push(index);
              }
            });
            this.total = res.returnObj.total;
            this.hasNext = res.returnObj.hasNextPage;
            this.setTableSelect(selectedIndexs);
          } else {
            this.$message.error(res.msgContent);
          }
        }
      );
    },
    setTableSelect(selectedIndexs) {
      this.$nextTick(() => {
        if (selectedIndexs && selectedIndexs.length) {
          selectedIndexs.forEach((item) => {
            this.$refs.dataTable.toggleRowSelection(
              this.$refs.dataTable.data[item],
              true
            );
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.choose-notice {
  .search-area {
    margin-bottom: 10px;
  }
  .search-input {
    width: 300px;
    margin-right: 10px;
  }
  .content-area {
    height: 430px;
  }

  .select-area {
    height: 26px;
  }

  .select-item {
    padding: 5px 10px;
    border-radius: 3px;
    @include set_theme_color(background-color, input-default-bg-color);
    @include set_theme_color(color, font-default-color);
    margin-right: 10px;
    cursor: pointer;
  }

  .el-dialog__body {
    padding: 20px;
  }
}
</style>